import * as ObjectUtils from "../../../utils/Property";
import React from 'react';

export const getCalculationResult = (dateStart, dateEnd, calculationResult, i18n) => {
    if (dateStart !== undefined && dateEnd !== undefined) {
        const currencyMark = ObjectUtils.getCurrencyMarkByValue(calculationResult.currency);

        let tableRows = [];
        let extraRows = [];

        calculationResult.rows.forEach((elem, index) => {
            const text = elem.text;

            tableRows.push(
                <tr key={`${index}_${elem.value}`}>
                    <td>
                        {prepareCalculationMessage(text, i18n)}
                    </td>
                    <td>
                        {Math.round(elem.value)}&nbsp;{currencyMark}
                    </td>
                </tr>
            );
        });

        calculationResult.extra.forEach((elem, index) => {
            const text = elem.text;

            extraRows.push(
                <tr key={`${index}_${elem.value}`}>
                    <td>
                        {prepareCalculationMessage(text, i18n)}
                    </td>
                    <td>
                        {Math.round(elem.value)}&nbsp;{currencyMark}
                    </td>
                </tr>
            );
        });

        return (
            <div>
                <table className="book-it-calculation-result">
                    <tbody>
                    {tableRows.map(elem => {
                        return elem;
                    })}
                    <tr>
                        <td>{i18n['invoice.total']}</td>
                        <td>
                            {Math.round(calculationResult.total)}&nbsp;{currencyMark}
                        </td>
                    </tr>

                    {extraRows.length != 0 && <tr>
                        <td colSpan={2}>
                            <hr/>
                        </td>
                    </tr>}

                    {extraRows.map(elem => {
                        return elem;
                    })}

                    </tbody>
                </table>
            </div>
        )
    }
};


export const prepareCalculationMessage = (text, i18n)=>{
    const key = text.substring(text.indexOf('##') + 2, text.lastIndexOf('##'));

    return `${text.substring(0, text.indexOf('##'))} ${i18n[key]} ${text.substring(text.lastIndexOf('##') + 2)}`;
}


// WEBPACK FOOTER //
// ./src/components/PropertyPage/Rental/CalculationUtils.js